<template>
  <div class="w-full px-[25px] py-[10px] footer">
    <p class="text-[7.82px] font-bold leading-[11.72px] text-white mb-[6px]">
      &copy; 2025 Procter &amp; Gamble
    </p>
    <div class="footer__links">
      <a
        href="https://termsandconditions.pg.com/en-in/#use"
        target="_blank"
        rel="noreferrer"
        class="text-white text-[7.82px] leading-[11.72px] underline"
        >Terms &amp; Conditions</a
      >
      <a
        href="https://privacypolicy.pg.com/en-IN/"
        target="_blank"
        rel="noreferrer"
        class="text-white text-[7.82px] leading-[11.72px] underline"
        >Privacy</a
      >
      <a
        href="https://privacypolicy.pg.com/en-IN/"
        target="_blank"
        rel="noreferrer"
        class="text-white text-[7.82px] leading-[11.72px] underline"
        >AdChoices</a
      >
      <a
        class="flex items-center text-white text-[7.82px] leading-[11.72px]"
        target="_blank"
        href="https://preferencecenter.pg.com/en-in/"
      >
        Your Privacy Choices
        <span>
          <img
            src="@/assets/images/privacy.svg"
            alt="Your Privacy Choices"
            class="privacy-icon"
          />
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
<style scoped>
.footer {
  background: linear-gradient(180deg, #1c5991 0%, #081e3d 100%);
}
.footer__links {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 8px;
}
.privacy-icon {
  width: 12px;
  margin-left: 4px;
}
</style>
